import { ArrowUp } from "lucide-react";
import { useScrolledPast } from "@/hooks/useScrolledPast";

const PAST_HERO_PX = 600;

export default function BackToTop() {
  const visible = useScrolledPast(PAST_HERO_PX);

  if (!visible) return null;
  return (
    <button
      type="button"
      data-testid="back-to-top"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Back to top"
      className="hidden md:flex fixed md:bottom-6 md:left-6 z-[1050] w-14 h-14 rounded-full bg-[#7A6547] text-[#F9F6F0] items-center justify-center shadow-[0_10px_30px_-8px_rgba(31,30,28,0.55)] ring-2 ring-white/40 hover:bg-[#1F1E1C] hover:text-[#C8B387] transition-colors"
    >
      <ArrowUp size={24} strokeWidth={2} />
    </button>
  );
}
